import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'

import telegram from "../../../assets/images/telegram.png"
import twitter from "../../../assets/images/twitter.png"
import styled from '@emotion/styled'

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
justify-content: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
margin:0 5px;
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`

height: 327px;
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const S7_Roadmap = () => {
    return (
        <div>
            <SectionWrapper p599="12rem 0 0" p="8rem 0 0" id="roadmap">
                <Container maxWidth="xl">

                    <GridHEading container spacing={3} >
                        <GridImage item xs={12} md={7}lg={8}xl={9} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">

                            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                <a href="https://twitter.com/babyhex_pulse" target="blank" data-aos="zoom-in-up"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="500"
                                    data-aos-duration="500"
                                    data-aos-offset="0">
                                    <JOiningLinks src={twitter} />
                                </a>
                                <a href="https://t.me/babyhexpulse" target="blank" data-aos="zoom-in-up"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="600"
                                    data-aos-duration="500"
                                    data-aos-offset="0">
                                    <JOiningLinks src={telegram} />
                                </a>
                            </div>
                            <SectionSmallHeading align="center">Disclosures and Legalease</SectionSmallHeading>
                            <P align="center"
                                p="20px 0"
                                m="0"
                                data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-duration="600"
                                data-aos-offset="0"
                            >
                               Please conduct thorough research and consider your risk tolerance before making any investment decisions. The information provided on this website is for informational purposes only and should not be considered financial advice. Baby Hex and the Pulse Chain team do not guarantee investment outcomes, and investors should be aware of the potential for loss of capital.
                            </P>

                        </GridImage>

                    </GridHEading>
                    <P align="center"
                        p="60px 0 20PX"
                        m="0"
                        data-aos="fade-zoom-in"
                        data-aos-easing="ease-in"
                        data-aos-delay="600"
                        data-aos-duration="600"
                        data-aos-offset="0"
                    >
                        © 2023 by BABYHEX. All rights reserved!</P>
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S7_Roadmap